import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatus = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "32px",
	height: "32px",
	viewBox: "0 0 32 32",
	style: { enableBackground: "new 0 0 32 32" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("polygon", {
		id: "icon_triangle_1_",
		points: "0,32 16,4 32,32 "
	}), /* @__PURE__ */ _jsxs("g", {
		id: "symbol_i",
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 13.5,
			y: 12.4,
			width: 5,
			height: 10.7
		}), /* @__PURE__ */ _jsx("rect", {
			x: 13.5,
			y: 25.6,
			width: 5,
			height: 3.8
		})]
	})]
});
export default SvgStatus;
